import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-701df069.js';
import { T as Tab, t as tabMarginsBase, a as tabMarginsSmall } from './Tab-50138685.js';
import { a as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-189dc982.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-12ae0974.js';

const getMobileMargin = () => ({
  theme,
  size
}) => size === 'small' ? theme.navigation.tabs.mobile.marginEndSmall : theme.navigation.tabs.mobile.marginEndBase;
const NavItem = /*#__PURE__*/styled.li.withConfig({
  componentId: "sc-storm-ui-30039089__sc-h00w4x-0"
})(["display:inline-flex;align-items:baseline;position:relative;", ";", " ", " ", ""], ({
  theme,
  size
}) => {
  switch (size) {
    case 'small':
      return tabMarginsSmall(theme);
    default:
      return tabMarginsBase(theme);
  }
}, ({
  $isActive,
  theme
}) => $isActive && css(["::after{position:absolute;content:'';height:3px;margin:0;bottom:0;left:0;right:0;background:", ";border-radius:2px 2px 0 0;}"], theme.card.tabs.activeBorder), ({
  $isActive,
  $selectable,
  theme
}) => !$isActive && $selectable && css([":hover::after{position:absolute;content:'';height:3px;margin:0;bottom:0;left:0;right:0;background:", ";border-radius:2px 2px 0 0;}"], theme.card.tabs.activeBorder), isMobile(css(["margin-inline-end:", ";white-space:nowrap;"], getMobileMargin())));
NavItem.displayName = 'NavItem';
class TabbedNavigationItem extends PureComponent {
  render() {
    const {
      id,
      active,
      label,
      href,
      onClick,
      renderStart,
      renderEnd,
      size,
      taktId,
      taktValue,
      ...rest
    } = this.props;
    return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
      taktId: taktId,
      fallbackId: createStormTaktId('tabbed-navigation-item')
    }, ({
      getDataTaktAttributes
    }) => /*#__PURE__*/React__default.createElement(NavItem, {
      id: id,
      role: "presentation",
      size: size,
      $isActive: active,
      $selectable: !!href || !!onClick
    }, renderStart && renderStart(), /*#__PURE__*/React__default.createElement(Tab, _extends({}, rest, {
      active: active,
      dataTaktAttributes: getDataTaktAttributes({
        taktValue
      }),
      href: href,
      label: label,
      onClick: onClick,
      size: size
    })), renderEnd && renderEnd()));
  }
}
_defineProperty(TabbedNavigationItem, "propTypes", {
  /**
   * The page unique identifier of the TabbedNavigationItem.
   */
  id: PT.string,
  /**
   * The label of the navigation item.
   */
  label: PT.node.isRequired,
  /**
   * Sets the navigation item to active.
   */
  active: PT.bool,
  /**
   * If an href is passed, the rendered element will be an <a> tag instead of a <button>.
   */
  href: PT.string,
  /**
   * Handles the click event fired when a navigation item is clicked.
   */
  onClick: PT.func,
  /**
   * The size of the navigation item.
   */
  size: PT.oneOf(['base', 'small']),
  /**
   * Render a component before the clickable navigation Item
   */
  renderStart: PT.func,
  /**
   * Render a component after the clickable navigation Item
   */
  renderEnd: PT.func
});
_defineProperty(TabbedNavigationItem, "defaultProps", {
  id: undefined,
  active: false,
  href: undefined,
  onClick: undefined,
  size: 'base',
  renderStart: undefined,
  renderEnd: undefined
});

export { TabbedNavigationItem as T };
//# sourceMappingURL=TabbedNavigationItem-41e6a6a7.js.map
